import EndPointNet from '@/functions/axios/axios-bearer';
import Vue from 'vue';
const state = {
  lista: [], // solo no vistas, o todas si quieres usar un filtro
  refreshFlag: false
};

const mutations = {
  SET_NOTIFICACIONES(state, notificaciones) {
    state.lista = notificaciones.map(n => ({
      ...n,
      Visto: n.Visto ?? false
    }));
    //state.lista = notificaciones;
  },
  MARCAR_VISTA(state, id) {
    const noti = state.lista.find(n => n.Id === id);
    if (noti) Vue.set(noti, 'Visto', true);
    //if (noti) noti.Visto = true; // o removerla si solo muestras no vistas
  },
  SET_REFRESH_FLAG(state, value) {
    state.refreshFlag = value;
  }
};

const actions = {
   cargarNotificaciones({ commit },{usuario}) {      
     EndPointNet.get(`Notificacion/${usuario}`)
        .then(response => {
          if (response.status === 200) {
            commit('SET_NOTIFICACIONES', response.data);
          }
        })
        .catch(() => {
          //console.error('Error al consultar asistencia:', error)
        });
  },
   marcarComoVista({ commit }, { id, usuario }) {
       EndPointNet.put(`Notificacion/${id}/vista`, { Usuario : usuario}
      )
        .then(response => {
          if (response.status === 200) {
            commit('MARCAR_VISTA', id); 
            commit('SET_REFRESH_FLAG', true);
            setTimeout(() => commit('SET_REFRESH_FLAG', false), 100); 
          }
        })
        .catch(() => {
          //console.error('Error al consultar asistencia:', error)
        });
  }
};

const getters = {
  noVistas: state => state.lista.filter(n => !n.Visto),
  totalNoVistas: (state, getters) => getters.noVistas.length
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
